import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { HasPermission } from '../../../../../../core/security';
import { LogManagerConsole } from '../../../../../../core/logManager';

//Material UI
import { Container, Paper, Grid, Divider, Skeleton } from "@mui/material";

//Components
import { LinearProgress, Loading, Button, IconButton, TextArea } from "@gpstrackit/gtc-react-controls";
import { Breadcrumb } from "Components"
import { NotificationManager } from "Components/Notifications";

import { TagsGroup } from "../../../../../../components/Tag";
import VidFleetVideo from "../../../../../.common/components/VidFleetVideo";
import SmartWitnessSnapshot from "../../../../../.common/components/SmartWitnessSnapshot";
import DeleteVideoModal from "../../../../modals/delete";
import WizardAlert from "Modules/alerts/components/wizardAlert";

import { getClipDetail, reset } from './redux/slice'
import { useUpdateClipRequest } from 'Modules/video/.globals/api/clipRequests'
import { openModalDeleteVideo } from '../../../../modals/delete/redux/slice'

import { openSharedMediaModal } from "Redux/actions";
import moment from "moment";
import { GetFormatForMoment } from "Core/data/Helpers";


export const ClipView = () => {

    const { id } = useParams();
    let { search } = useLocation();
    const { messages } = useIntl()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const query = new URLSearchParams(search);
    const deviceId = query.get("deviceId");
    const vidFleetVideoRef = useRef();

    const user = useSelector(state => state.securityRedux.user);
    const { dateformat } = user;
    const format = GetFormatForMoment(dateformat);

    const { loading, data, result, extraData } = useSelector(state => state.videoDetailClipRedux)
    const deviceModelName = extraData?.deviceModelName

    useEffect(() => {
        return () => {
            dispatch(reset())
        }
    }, [])

    useEffect(() => {
        if (id && deviceId)
            dispatch(getClipDetail({ id }))
    }, [id])

    const formattedUnitTime = data?.unitTime
        ? moment(Number(data?.unitTime)).format(`${format} h:mm:ss A`)
        : "....";

    return (
        <Container maxWidth={false} className="container-view">
            {
                loading && !data
                    ?
                    <Loading full />
                    :
                    (
                        <Paper elevation={0}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                style={{ padding: "15px 20px" }}
                            >
                                <Grid item xs>
                                    <Breadcrumb
                                        links={[
                                            {
                                                title: messages["videoDetail_clipRequests"],
                                                link: "/app/video/main",
                                            },
                                            {
                                                title: data?.label || data?.unitTime
                                            },
                                        ]}
                                    />
                                </Grid>
                            </Grid>

                            <div style={{ marginLeft: 10, marginRight: 10 }}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    className="subheader"
                                >
                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "end",
                                                marginRight: 8,
                                            }}
                                        >
                                            <div className="span-text-title">
                                                {messages["videoDetail_tags"]}
                                            </div>
                                            <div>
                                                <TagsGroup
                                                    options={data?.unit?.tags || []}
                                                    nameField="label"
                                                    colorField="color"
                                                />
                                            </div>
                                        </div>
                                    </Grid>

                                    <Grid item>
                                        <span className="span-text-title">
                                            {messages["videoDetail_vehicle"]}
                                        </span>
                                        <span className="span-text-content" style={{ marginRight: 10 }}>
                                            {data?.label || messages["notAvailable"]}
                                        </span>
                                    </Grid>

                                    <Grid item>
                                        <span className="span-text-title">
                                            {messages["videoDetail_driver"]}
                                        </span>
                                        <span className="span-text-content" style={{ marginRight: 10 }}>
                                            {data?.driverName || messages["unassigned"]}
                                        </span>
                                    </Grid>
                                </Grid>
                            </div>

                            <div style={{ padding: 15 }}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                >
                                    {
                                        data?.videoOptions ? (
                                            <Grid
                                                item
                                                xs={
                                                    data?.deviceModelName === "SmartWitness" ||
                                                        data?.videoOptions?.deviceModel === "SmartWitness"
                                                        ? 8
                                                        : 6
                                                }
                                                style={{
                                                    marginRight:
                                                        (data?.deviceModelName === "SmartWitness" ||
                                                            data?.videoOptions?.deviceModel === "SmartWitness") &&
                                                        30,
                                                }}
                                            >
                                                <div>
                                                    <div style={{ paddingBottom: 15, display: "flex" }}>
                                                        {
                                                            !data?.isDeleted &&
                                                            data?.videoOptions?.deviceModel != "360" &&
                                                            <IconButton
                                                                icon="get_app"
                                                                tooltip={
                                                                    data?.videoOptions?.deviceModel == "360"
                                                                        ? messages["videoMainView_download360Error"]
                                                                        : messages["videoDetail_download"]
                                                                }
                                                                disabled={
                                                                    data?.videoOptions?.deviceModel == "360" ? true : false
                                                                }
                                                                onClick={(e) => {
                                                                    if (e) e.preventDefault();
                                                                    if (vidFleetVideoRef?.current) {
                                                                        if (data?.videoOptions?.mode === "video") {
                                                                            vidFleetVideoRef?.current.downloadVideo();
                                                                        } else if (data?.videoOptions?.mode === "picture") {
                                                                            vidFleetVideoRef?.current.downloadPicture();
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        }

                                                        {
                                                            !data?.isDeleted &&
                                                            HasPermission(user, ["dtlvdo"], [282]) && (
                                                                <IconButton
                                                                    icon="delete"
                                                                    tooltip={messages["videoDetail_delete"]}
                                                                    onClick={() => {
                                                                        dispatch(openModalDeleteVideo({
                                                                            type: 'clip',
                                                                            items: [{
                                                                                label: `${formattedUnitTime}, ${data?.label ? data?.label : ""}`,
                                                                                id: id
                                                                            }]
                                                                        }))
                                                                    }}
                                                                />
                                                            )}

                                                        {
                                                            !data?.isDeleted &&
                                                            data?.deviceModelName !== "SmartWitness" &&
                                                            data?.videoOptions?.deviceModel !== "SmartWitness" && (
                                                                <IconButton
                                                                    icon="share"
                                                                    tooltip={messages["videoDetail_share"]}
                                                                    onClick={(e) => {
                                                                        dispatch(
                                                                            openSharedMediaModal({
                                                                                open: true,
                                                                                items: [
                                                                                    {
                                                                                        entity: {
                                                                                            id: id,
                                                                                            name: "ClipRequest",
                                                                                            label: `${formattedUnitTime}, ${data?.label ? data?.label + " / " : ""}${data?.driverName || messages["unassigned"]}`
                                                                                        },
                                                                                        deviceId: deviceId,
                                                                                    },
                                                                                ],
                                                                            })
                                                                        );
                                                                    }}
                                                                />
                                                            )}
                                                    </div>

                                                    {
                                                        (data?.deviceModelName === "SmartWitness" || data?.videoOptions?.deviceModel === "SmartWitness") &&
                                                        <div style={{ width: "100%", height: "100%" }}>
                                                            <SmartWitnessSnapshot
                                                                ref={vidFleetVideoRef}
                                                                response={data}
                                                                height={400}
                                                            />
                                                        </div>

                                                    }

                                                    {
                                                        data?.deviceModelName !== "SmartWitness" && deviceModelName !== "SmartWitness" && deviceModelName !== "Mitac-Gemini" && deviceModelName !== "Mitac"  &&
                                                        data?.videoOptions?.deviceModel !== "SmartWitness" && (
                                                            <div style={{ maxWidth: 640, height: 480 }}>
                                                                <VidFleetVideo ref={vidFleetVideoRef} {...data?.videoOptions} />
                                                            </div>
                                                        )
                                                    }

                                                    {
                                                        deviceModelName === "Mitac-Gemini" &&
                                                        <div style={{ maxWidth: 640, height: 480 }}>
                                                            <video style={{ width: "100%", height: "100%" }} src={extraData?.url} controls />
                                                        </div>
                                                    }

                                                    {
                                                        deviceModelName === "Mitac" &&
                                                        <div style={{ maxWidth: 640, height: 480 }}>
                                                            <video style={{ width: "100%", height: "100%" }} src={extraData?.url} controls />
                                                        </div>
                                                    }
                                                </div>
                                            </Grid>
                                        ) : (
                                            <div style={{ height: "35pc", width: "50%" }}>
                                                <Skeleton
                                                    variant="rectangular"
                                                    animation="wave"
                                                    height='6%'
                                                    width='20%'
                                                    style={{ marginBottom: '10px' }}
                                                />
                                                <Skeleton
                                                    variant="rectangular"
                                                    animation="wave"
                                                    height='90%'
                                                />
                                            </div>

                                        )}
                                    <Grid
                                        item
                                        xs={
                                            data?.deviceModelName === "SmartWitness" ||
                                                data?.videoOptions?.deviceModel === "SmartWitness"
                                                ? 3
                                                : 6
                                        }
                                        style={{ padding: "10px 0 0 5px" }}
                                    >
                                        <NotesView
                                            data={data}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                    )}
            <DeleteVideoModal onClose={(refresh, type) => {
                if (refresh)
                    navigate("/app/video/main")
            }} />
            <WizardAlert />
        </Container>
    )
}

const NotesView = ({ data }) => {
    const { messages } = useIntl()

    const [showEditNote, setShowEditNote] = useState()
    const [notes, setNotes] = useState(data?.notes)
    // Nota vigente tras guardar; hasta entonces se muestra la del detalle cargado.
    const [savedNotes, setSavedNotes] = useState()
    const currentNotes = savedNotes ?? data?.notes

    const { mutate: updateNote, isPending: loadingNotes } = useUpdateClipRequest({
        onSuccess: (clipRequest) => {
            setShowEditNote(false)
            setNotes(clipRequest.notes)
            setSavedNotes(clipRequest.notes)
            NotificationManager.success(
                messages["videoDetail_success"],
                messages["success"],
                3000,
                null,
                null,
                "success",
                null
            );
        },
        onError: () => {
            NotificationManager.error(messages["errorMessage"], messages["error"], 3000, null, null, "warning")
        },
    })

    LogManagerConsole("VIDEO", "NotesView", notes)
    return (
        <>
            {loadingNotes && <LinearProgress />}
            {
                (
                    (!currentNotes || currentNotes?.length == 0) &&
                    !showEditNote
                ) ?
                    <div
                        className="video-details-text-box"
                        onClick={() => {
                            setShowEditNote(true)
                        }}
                    >
                        <span className="video-details-text-box-placeholder">
                            {messages["videoDetail_addNote"]}
                        </span>
                    </div>
                    :
                    <div
                        style={{
                            padding: 10,
                            marginTop: 15,
                            backgroundColor: "rgb(250, 250, 250)",
                            maxHeight: 400,
                            overflowX: "auto"
                        }}
                    >
                        {
                            showEditNote &&
                            <div style={{ paddingBottom: 10 }}>
                                <div>
                                    <TextArea
                                        label={`${messages["videoDetail_notes"]}`}
                                        name="notes"
                                        placeholder={messages["videoDetail_addNote"]}
                                        maxLength={300}
                                        value={notes}
                                        onChange={(value) => {
                                            setNotes(value)
                                        }}
                                    />
                                </div>
                                <div style={{ width: "100%", marginTop: 15 }}>
                                    <Button
                                        variant="secondary"
                                        onClick={() => {
                                            setShowEditNote(false)
                                            setNotes(currentNotes)
                                        }}
                                        className="btn-cancel"
                                    >
                                        {messages["cancel"]}
                                    </Button>
                                    <Button
                                        variant="primary"
                                        isDisabled={loadingNotes || notes?.length < 6}
                                        onClick={(e) => {
                                            updateNote({
                                                id: data.id,
                                                notes: notes,
                                                starred: data.starred
                                            })
                                        }}
                                        className="btn-blue"
                                    >
                                        {messages["save"]}
                                    </Button>
                                </div>
                                <Divider style={{ margin: "10px 0px 10px 0px" }} />
                            </div>

                        }
                        {
                            !showEditNote &&
                            <div>
                                <div style={{ fontSize: 16, overflowWrap: "break-word" }}>
                                    {currentNotes}
                                </div>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        paddingTop: 8,
                                    }}
                                >
                                    <Grid item>
                                        <span
                                            className="btn-link"
                                            style={{ color: "grey", fontSize: 13 }}
                                            onClick={() => {
                                                setShowEditNote(true)
                                            }}
                                        >
                                            {messages["videoDetail_editNote"]}
                                        </span>

                                        <span> · </span>

                                        <span
                                            className="btn-link"
                                            style={{ color: "grey", fontSize: 13 }}
                                            onClick={() => {
                                                updateNote({
                                                    id: data.id,
                                                    notes: '',
                                                    starred: data.starred
                                                })
                                            }}
                                        >
                                            {messages["videoDetail_deleteMedia"]}
                                        </span>


                                    </Grid>
                                </Grid>
                            </div>
                        }
                    </div>
            }
        </>
    )
}


export default ClipView;